import { OrganizationOverviewPage } from '@oneclick/pages/overview/OrganizationOverviewPage';
import { OVERVIEW_ROUTE_SEGMENTS } from '@oneclick/constants/navigation';

import type { OneClickNavItem } from '@oneclick/routing';

export const OVERVIEW_ROUTE_CONFIG: OneClickNavItem[] = [
  {
    id: 'organization',
    title: 'Overview',
    route: OVERVIEW_ROUTE_SEGMENTS.organization,
    page: OrganizationOverviewPage,
    breadcrumbs: ['Overview'],
    rules: [
      ['view', 'ClusterAutomationNewDashboard'],
      ['view', 'OrganizationCostMonitoring'],
    ],
  },
];
